// extracted by mini-css-extract-plugin
export default {"charts":"StatisticsPage_charts__O2dhk"};